export default __webpack_public_path__ + "static/media/alumini (3).9dc428c8.jpg";